module.exports = __webpack_public_path__ + "static/media/urban-farming-desktop.744eec44.jpg";